module.exports = {"513338100":"松麦镇","513338101":"瓦卡镇","513338102":"白松镇","513338200":"斯闸乡","513338201":"徐龙乡","513338202":"日龙乡","513338203":"曲雅贡乡","513338204":"奔都乡","513338205":"八日乡","513338206":"古学乡","513338208":"贡波乡","513338210":"茨巫乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513338.json
// module id = 2243
// module chunks = 0